import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { first } from 'rxjs/operators';
import { clickGAEvent } from 'src/app/_helpers/ga-events';
import { AuthService } from 'src/app/_services/auth.service';
import { Router } from '@angular/router';
import { pageLoadEvent } from 'src/app/_helpers/ga-events';
import { addGAEventListener, removeGAEventListener } from 'src/app/_helpers/ga-events';
import * as Sentry from "@sentry/angular-ivy";

@Component({
  selector: 'app-existing-account',
  templateUrl: './existing-account.component.html',
  styleUrls: ['./existing-account.component.css'],
})
export class ExistingAccountComponent implements OnInit {
  loading: boolean = false;
  paramsObject!: any;
  token!: any;
  businessid!: any;
  userid!: any;

  businessData!: any;

  constructor(
    private authService: AuthService,
    private notification: NzNotificationService,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit(): void {
    pageLoadEvent("auth-existing-account_page")
    addGAEventListener();
    this.loading = true;

    this.route.queryParamMap.subscribe((params) => {
      this.paramsObject = { ...params };
      this.userid = this.paramsObject.params.uid;
      this.businessid = this.paramsObject.params.bid;
      this.token = this.paramsObject.params.token;
      this.token && this.authService.saveToken(this.token);
    },
    (error:any) => {
      Sentry.captureMessage('Error: ' + error);
    });

    this.getExistingBusinessDetails();
  }

  ngAfterViewInit(): void {
    removeGAEventListener();
    addGAEventListener();
  }

  ngOnDestroy(): void {
    removeGAEventListener();
  }

  getExistingBusinessDetails() {
    this.authService
      .getExistingBusiness(this.userid)
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.loading = false;
          let responseData: any;
          responseData = res;
          this.businessData = responseData.response;
        },
        error: (error : any) => {
          Sentry.captureMessage('Error: ' + error);
          this.loading = false;
        },
      });
  }

  requestToJoin() {
    clickGAEvent("button_click","request-to-join_click","auth-existing-account_page");
    // const payload = {
    //   email : ''
    // }
    // this.authService
    // .requestToJoinBusiness(payload)
    // .pipe(first())
    // .subscribe({
    //   next: (res) => {
    //     this.loading = false;
    //     let responseData: any;
    //     responseData = res;
    //     if (!responseData.error) {
    //       this.createNotification('success','Email Sent', 'The verification email has been resent to your email')
    //     }else{
    //       this.createNotification('error','Email not Sent', 'Error resending email');
    //     }
    //   },
    //   error: () => {
    //     this.loading = false;
    //     this.createNotification('error','Email not Sent', 'Error resending email');
    //   }
    // });
  }

  createNotification(type: string, title: string, body: string): void {
    this.notification.create(type, title, body);
  }

  getInitials(name: string = '') {
    let names = name.split(' '),
      initials = names[0].substring(0, 1).toUpperCase();

    if (names.length > 1) {
      initials += names[names.length - 1].substring(0, 1).toUpperCase();
    }
    return initials;
  }
  triggerGAButton():void{
    clickGAEvent("create_click","create-new_click","auth-existing-account_page");
    this.router.navigate(['/auth/newbusiness']);
  }

}
